var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-container",style:({
    border:
      _vm.dataObj.status === 1
        ? '1px dashed rgba(58,96,255,1)'
        : '1px solid #EDEFF2',
    padding: '3px 12.5px', // 6rpx 25rpx → 3px 12.5px
  })},[_c('div',{staticClass:"title-view"},[_c('div',{staticClass:"rich-text-content",domProps:{"innerHTML":_vm._s(_vm.dataObj.caseProblem)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a59e613","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionPreview/QuestionPreviewTitle.vue
// module id = Wuje
// module chunks = 3